import { Link } from "@StarberryUtils";
import React from "react";
import {Row, Col } from 'react-bootstrap';
import  "./Subscribe.scss";

import { inViewOptions } from '../../utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

const containerVariants = {
  hidden: {
    opacity: 0,
    y: -30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 0.4
    }
  }
}

const JoinMG=()=> {
  return(
    <InView {...inViewOptions}>
      {({ ref, inView }) => (
        <motion.div
          className="subscribe-card justify-content-between align-items-center components-News-Subscribe-Subscribe join-mg"
          ref={ref}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          variants={containerVariants}
        >
          <Row>
            <Col lg={8}>
              <h2 className="sec-title">Are you ready to join the Marty Gerrard team?</h2>
            </Col>
            <Col lg={4}>
              <Link to="" className="btn">Career Opportunities</Link>
            </Col>
          </Row>
        </motion.div>
      )}
    </InView>
  )
}
export default JoinMG
